import "./styles/Question.css";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Footer from "./Footer";

function Question(activeQuestion) {
    const navigate = useNavigate();

    const [questions, setQuestions] = useState([]);


    const [selectedService, setSelectedService] = useState("");
    const [showWarning, setShowWarning] = useState(false);
    const [showSoakWarning, setShowSoakWarning] = useState(activeQuestion.selected[3] === "I will not need a soak-off." ? true : false);
    const [bunnyPeeking, setBunnyPeeking] = useState(false);
    const [highlight, setHighlight] = useState(false);
    const questionHeaderRef = useRef();

    useEffect(() => {
        const fetchQuestions = async () => {
            try {
                const response = await axios.get("https://bunny-klawz.uc.r.appspot.com/questions");
                setQuestions(response.data);
            } catch (error) {
                console.error("Failed to fetch questions:", error);
            }
        };

        fetchQuestions();
    }, []);

    useEffect(() => {
        if (activeQuestion.selected[0]) {
            setShowWarning(true);
        }
        if (activeQuestion.selected[3] === "I will not need a soak-off.") {
            setShowSoakWarning(true)
        }
    }, [activeQuestion])

    const scrollToQuestionHeader = () => {
        if (questionHeaderRef.current) {
            questionHeaderRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    const scrollToTop = () => {
        if (activeQuestion.scrollRef.current) {
            activeQuestion.scrollRef.current.scrollIntoView({ top: 0, behavior: "smooth" });
        }
    };

    const timedHighlight = () => {
        setHighlight(true);
        setTimeout(() => {
            setHighlight(false);
        }, 2000);
    };

    const renderOptions = (options, questionIndex) => {
        return options.map((option, optionIndex) => (
            <label key={`${questionIndex}-${optionIndex}`}>
                {(questionIndex !== 0 &&
                    <input
                        type="radio"
                        name={`question-${questionIndex}`} // Ensure radio buttons are grouped per question
                        value={option.label}
                        checked={activeQuestion.selected[questionIndex] === option.label}
                        onChange={() => {
                            setSelectedService(option.label);
                            // let tempPS = activeQuestion.previousQuestions;
                            // tempPS.push(activeQuestion.activeQuestion);
                            // activeQuestion.setPreviousQuestions(tempPS);
                            activeQuestion.setSkips(option.skips);

                            let tempDurationList = activeQuestion.durationList;
                            tempDurationList[questionIndex] = option.time;
                            activeQuestion.setDurationList(tempDurationList);


                            let tempSelectedList = activeQuestion.selected;
                            tempSelectedList[questionIndex] = option.label;
                            tempSelectedList = tempSelectedList.slice(0, questionIndex + 1);
                            activeQuestion.setSelected(tempSelectedList);

                            let tempAnswers = activeQuestion.answers;
                            tempAnswers[questionIndex] = option;
                            tempAnswers = tempAnswers.slice(0, questionIndex + 1);
                            activeQuestion.setAnswers(tempAnswers);



                            console.log(tempAnswers);

                            if (questionIndex === 3 && optionIndex === 3) {
                                setShowSoakWarning(true);
                            } else {
                                // activeQuestion.setActiveQuestion(activeQuestion.activeQuestion + activeQuestion.skips + 1);
                                // activeQuestion.setSkips(0);
                                // scrollToQuestionHeader();
                            }
                        }}
                    />
                )}

                {(questionIndex === 0 &&
                    <input
                        type="radio"
                        name={`question-${questionIndex}`} // Ensure radio buttons are grouped per question
                        value={option.label}
                        checked={activeQuestion.selected[questionIndex] === option.label}
                        onChange={() => {
                            setSelectedService(option.label);
                            setShowWarning(true);
                            // let tempPS = activeQuestion.previousQuestions;
                            // tempPS.push(activeQuestion.activeQuestion);
                            // activeQuestion.setPreviousQuestions(tempPS);
                            activeQuestion.setSkips(option.skips);

                            let tempDurationList = activeQuestion.durationList;
                            tempDurationList[questionIndex] = option.time;
                            activeQuestion.setDurationList(tempDurationList);

                            let tempSelectedList = activeQuestion.selected;
                            tempSelectedList[questionIndex] = option.label;
                            tempSelectedList = tempSelectedList.slice(0, questionIndex + 1);
                            activeQuestion.setSelected(tempSelectedList);

                            let tempAnswers = activeQuestion.answers;
                            tempAnswers[questionIndex] = option;
                            tempAnswers = tempAnswers.slice(0, questionIndex + 1);
                            activeQuestion.setAnswers(tempAnswers);

                            console.log(tempAnswers);
                        }}
                    />
                )}
                {option.label}
            </label>
        ));
    };

    const renderQuestions = () => {
        return questions.map((question, questionIndex) => ((activeQuestion.activeQuestion === questionIndex + 1) &&
            <div ref={questionHeaderRef} key={questionIndex} className="fade">
                <div className="single-question">
                    <div className="question-header">
                        <h3>{question.question}</h3>
                        {([0].includes(questionIndex) && (
                            <p>
                                <span className={`${highlight ? "textHighlight" : ""}`}>Please select one. &nbsp;</span>
                                Click{" "}
                                <a
                                    // onClick={() => {
                                    //     navigate("/services");
                                    //     // setTimeout(() => { window.location.hash = "services"; }, 100);
                                    // }}
                                    href="https://bunnyklawz.com/services"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    here
                                </a>{" "}
                                to get more details on the different services.
                            </p>
                        ))}

                        {([2].includes(questionIndex) && (
                            <p>
                                <span className={`${highlight ? "textHighlight" : ""}`}>Please select one.&nbsp;</span>
                                Click{" "}
                                <a
                                    // onClick={() => {
                                    //     navigate("/services");
                                    //     setTimeout(() => { window.location.hash = "tiers"; }, 100);
                                    // }}
                                    href="https://bunnyklawz.com/services#tiers"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    here
                                </a>{" "}
                                to get more details on the different tiers.
                            </p>
                        ))}

                        {([3].includes(questionIndex) && (
                            <p>
                                <span className={`${highlight ? "textHighlight" : ""}`}>Please select one.&nbsp;</span>
                                Click{" "}
                                <a
                                    // onClick={() => {
                                    //     navigate("/services");
                                    //     setTimeout(() => { window.location.hash = "soak-offs"; }, 100);
                                    // }}
                                    href="https://bunnyklawz.com/services#soak-offs"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    here
                                </a>{" "}
                                to get more details on soak-off services.
                            </p>
                        ))}

                        {([1].includes(questionIndex) &&
                            <p>
                                <span className={`${highlight ? "textHighlight" : ""}`}>{question.description}</span>
                            </p>
                        )}
                    </div>
                    <div className={`options ${(questionIndex === 2) ? "randoImTired" : ""} ${highlight ? "highlight" : ""}`}>
                        {renderOptions(question.options, questionIndex)}
                    </div>
                    {(questionIndex === 0 && showWarning && <div className="question1 warning fade"><p className="warning-text"><img src="/images/Warning.png" alt="Warning" />Please note that a $10 deposit will be due at the time of booking. Deposit is included in the total cost.</p></div>)}
                    {(questionIndex === 3 && showSoakWarning && <div className="question1 warning fade"><p className="warning-text"><img src="/images/Warning.png" alt="Warning" />If you choose not to include a soak-off, last-minute requests at the appointment may result in cancellation.</p></div>)}
                </div>
            </div>
        ));
    };

    if (questions.length === 0) {
        return <div className="questions"><p>Loading...</p></div>;
    }

    return <div className="questions">{renderQuestions()}
        <div className="spacer"></div>
        <div className="questions-nav">
            {(activeQuestion.activeQuestion !== 1 && <button
                className="go-back"
                onClick={() => {
                    let previousQuestion = activeQuestion.previousQuestions[activeQuestion.previousQuestions.length - 1];
                    activeQuestion.setActiveQuestion(previousQuestion)

                    activeQuestion.setSkips(activeQuestion.answers[previousQuestion - 1].skips);
                    // console.log(previousQuestion);

                    // activeQuestion.setSkips(activeQuestion.selected[activeQuestion.activeQuestion].skips);

                    let tempPS = activeQuestion.previousQuestions;
                    tempPS.pop();
                    activeQuestion.setPreviousQuestions(tempPS);

                    scrollToQuestionHeader();
                }}
            >
                Go Back
            </button>)}
            {(activeQuestion.activeQuestion === 1 && <button className="placeholder">Go Back</button>)}
            <div className="continue">
                <img className={`continue-bunny ${bunnyPeeking ? "hovered" : ""}`} src="/images/ContinueBunny.png" alt="Continue Bunny" />
                <button
                    className="continue-button"
                    onMouseEnter={() => setBunnyPeeking(true)}
                    onMouseLeave={() => setBunnyPeeking(false)}
                    onClick={() => {
                        console.log("Active: " + activeQuestion.activeQuestion);
                        console.log("Previous: " + activeQuestion.previousQuestions);
                        console.log("Skips: " + activeQuestion.skips);

                        if (!activeQuestion.selected[activeQuestion.activeQuestion - 1]) {
                            timedHighlight();
                            return;
                        }

                        let tempPS = activeQuestion.previousQuestions;
                        tempPS.push(activeQuestion.activeQuestion);
                        activeQuestion.setPreviousQuestions(tempPS);
                        activeQuestion.setActiveQuestion(activeQuestion.activeQuestion + activeQuestion.skips + 1)
                        activeQuestion.setSkips(0);

                        { (activeQuestion === 4) ? scrollToTop() : scrollToQuestionHeader() }
                    }}
                >Continue</button>
            </div>
        </div>
        <Footer />
    </div>;
}

export default Question;
